<template>
  <Modal v-model="logoutModal" :close="() => { setModal(false) }">
    <div class="lcu-modal">
      <div v-if="!loading">
        <div class="row">
          <p class="lcu-center-text">
            ¿Estás seguro de que quieres cerrar sesión?
          </p>
        </div>
        <div>
          <button-cta
            :text="'Sí, cerrar sesión'"
            :classes="['full-width-btn']"
            @on-click="logout" />
        </div>
      </div>
      <div class="row row-center" v-if="loading">
        <SpinLoader :size="'100px'" />
      </div>
    </div>
  </Modal>
</template>

<script>
import ButtonCta from 'ç/buttons/Cta.vue';
import Auth from '@/mixins/Auth.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';

export default {
  name: 'logout-modal',
  components: {
    ButtonCta,
    SpinLoader,
  },
  mixins: [Auth],
  props: ['logout-modal'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async logout() {
      try {
        this.setModal(false);
        this.loading = true;
        await this.$logout();
        this.loading = false;
        this.$router.push({ path: '/iniciar-sesion' });
        setTimeout(() => {
          this.$clearAuthStorage();
          this.$store.dispatch('logoutUser');
        }, 300);
      } catch (e) {
        this.$log.error(e.message || e);
      }
    },
    setModal(val) {
      this.$emit('set-modal', val);
    },
  },
};
</script>

<style scoped lang="scss">
.full-width-btn {
  width: 100%;
}
</style>
